export default "__VITE_ASSET__C8IS7otx__"